<template>
  <div>
    <SubTitle align="center"
              text="¡ Inicio de planificación exitosa !"/>
    <div class="card-section">
      <p class="title">Nº DE SEGUIMIENTO</p>
      <p class="order">{{this.planningTracker}}</p>
    </div>
    <div align="center">
      <p class="continue">ahora puedes continuar realizando una:</p>
      <el-button class="flat"
                 @click="goToPlanning">NUEVA PLANIFICACIÓN</el-button>
      <el-button class="default"
                 @click="goToStatusView">REVISIÓN DE ESTADO</el-button>
    </div>
  </div>
</template>

<script>
import SubTitle from '../base/SubTitle.vue';

export default {
  props: {
    planningTracker: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  name: 'PlanningSuccess',
  components: {
    SubTitle,
  },
  methods: {
    goToPlanning(r) {
      this.$router.go(r);
    },
    goToStatusView() {
      this.$router.push('status');
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    padding: 0 17%;
    width: fit-content;
    margin: 0 auto 20px auto;
    border: 1px solid #E0E0E0;
    .title {
      color: #616161;
      font-weight: 900;
      margin: 32px 0 0 0;
    }
    .order {
      color: #AAD500;
      font-size: 60px;
      font-weight: 300;
      margin: 0 0 20px 0;
    }
  }
  .continue {
    margin-top: 35px;
    font-size: 14px;
    font-weight: 300;
    color: #606060;
  }
</style>
